import { PREFIX_URL } from '@/api/config';
import { axios } from '@/lib/axios/axios';

/**
 * PATCH /api/accounts/:id/status — answers 204, so there is nothing to unwrap.
 * showError: false keeps the axios interceptor's generic toast away; the modal renders
 * the failure inline where the action was taken.
 */
export const updateAccountStatus = (
  id: number,
  isActive: boolean
): Promise<void> =>
  axios.patch(
    `${PREFIX_URL}/accounts/${id}/status`,
    { 'is-active': isActive },
    { showError: false }
  );
